import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Field, Formik } from 'formik';
import { useCallback, useRef } from 'react';
import { DataExportOptions } from '../../data/SpectraManager';
import { useChartData } from '../context/ChartContext';
import ActionButtons from '../elements/ActionButtons';
import CloseButton from '../elements/CloseButton';
import FormikCheckBox from '../elements/formik/FormikCheckBox';
import FormikInput from '../elements/formik/FormikInput';
import { ModalStyles } from './ModalStyle';
const styles = css `
  .inner-content {
    flex: 1;
  }

  .custom-label {
    width: 100px;
  }

  .name {
    width: 100% !important;
    text-align: left !important;
  }

  .data-export-group {
    label {
      margin-right: 10px;
      display: inline-block;
    }

    input[type='radio'] {
      margin-right: 5px;
    }
  }
`;
const INITIAL_VALUE = {
    name: '',
    compressed: false,
    pretty: false,
    include: {
        dataType: DataExportOptions.ROW_DATA,
        view: false,
        settings: false,
    },
};
function SaveAsModal({ onClose, onSave, name }) {
    const refForm = useRef();
    const { source } = useChartData();
    const handleSave = useCallback(() => {
        refForm.current.submitForm();
    }, []);
    const submitHandler = useCallback((values) => {
        onSave(values);
        onClose?.();
    }, [onClose, onSave]);
    return (_jsxs("div", { css: [ModalStyles, styles], children: [_jsxs("div", { className: "header handle", children: [_jsx("span", { children: "Save as ... " }), _jsx(CloseButton, { onClick: onClose, className: "close-bt" })] }), _jsx("div", { className: "inner-content", children: _jsx(Formik, { innerRef: refForm, initialValues: { ...INITIAL_VALUE, name }, onSubmit: submitHandler, children: _jsxs(_Fragment, { children: [_jsxs("div", { className: "row margin-10", children: [_jsx("span", { className: "custom-label", children: "Name" }), _jsx(FormikInput, { name: "name", className: "name", style: {
                                            inputWrapper: { width: '100%' },
                                        } })] }), _jsxs("div", { className: "row margin-10", children: [_jsx("span", { className: "custom-label", children: "Compressed" }), _jsx(FormikCheckBox, { name: "compressed" })] }), _jsxs("div", { className: "row margin-10", children: [_jsx("span", { className: "custom-label", children: "Pretty Format" }), _jsx(FormikCheckBox, { name: "pretty" })] }), _jsxs("div", { className: "row margin-10", children: [_jsx("span", { className: "custom-label", children: " Include view " }), _jsx(FormikCheckBox, { name: "include.view" })] }), _jsxs("div", { className: "row margin-10", children: [_jsx("span", { className: "custom-label", children: " Include settings " }), _jsx(FormikCheckBox, { name: "include.settings" })] }), _jsxs("div", { className: "row margin-10", children: [_jsx("span", { className: "custom-label", children: " Include Data " }), _jsx("div", { style: { display: 'flex', flexDirection: 'column' }, children: _jsxs("div", { className: "data-export-group", children: [_jsxs("label", { children: [_jsx(Field, { type: "radio", name: "include.dataType", value: DataExportOptions.ROW_DATA }), "Raw Data"] }), _jsxs("label", { style: {
                                                        color: source ? 'black' : 'lightgray',
                                                    }, children: [_jsx(Field, { type: "radio", name: "include.dataType", value: DataExportOptions.DATA_SOURCE, disabled: !source }), "Data Source"] }), _jsxs("label", { children: [_jsx(Field, { type: "radio", name: "include.dataType", value: DataExportOptions.NO_DATA }), "No Data"] })] }) })] })] }) }) }), _jsx("div", { className: "footer-container", children: _jsx(ActionButtons, { style: { flexDirection: 'row-reverse', margin: 0 }, onDone: handleSave, doneLabel: "Save", onCancel: () => onClose?.() }) })] }));
}
export default SaveAsModal;
